import { useCallback } from "react";
import { Brand, Location } from "../types/mapData";

interface UseMapHandlersProps {
  map: google.maps.Map | null;
  oval: string;
  setCenter: (latLng: google.maps.LatLngLiteral | google.maps.LatLng) => void;
  setListState: (state: number) => void;
  setCurLoc: (location: Location | null) => void;
  setCurBrand: (brandId: number) => void;
  setCurMarker: (marker?: google.maps.Marker | null) => void;
  handleAmplitude: (
    eventName: string,
    eventProperties?: Record<string, any>,
  ) => void;
  curMarkerRef: React.MutableRefObject<google.maps.Marker | null>;
  setUserLocation: (location: {
    isSearch: boolean;
    isLoc: boolean;
    location: number[];
  }) => void;
  loadingDetails: boolean;
}

export function useMapHandlers({
  map,
  oval,
  setCenter,
  setListState,
  setCurLoc,
  setCurBrand,
  setCurMarker,
  handleAmplitude,
  curMarkerRef,
  setUserLocation,
  loadingDetails,
}: UseMapHandlersProps) {
  const handleCurMarker = useCallback(
    (marker?: google.maps.Marker | null) => {
      if (marker?.location?.name === curMarkerRef.current?.location?.name)
        return;

      curMarkerRef.current?.setZIndex(curMarkerRef.current?.saveZIndex ?? 0);
      curMarkerRef.current?.setIcon({
        url: oval,
        labelOrigin: new google.maps.Point(15.5, 14),
      });
      setCurMarker(marker);
    },
    [oval, curMarkerRef, setCurMarker],
  );

  const handleBrandInfoClick = useCallback(
    (
      location: Location,
      locMarker: google.maps.Marker | undefined,
      brandId?: number,
    ) => {
      if (!locMarker) return;
      handleAmplitude("click_list_content");
      const bounds = map?.getBounds();
      // @ts-ignore
      if (bounds && !bounds.contains(locMarker.getPosition())) {
        setCenter(locMarker.getPosition());
        const searchLoc: {
          isSearch: boolean;
          isLoc: boolean;
          location: number[];
        } = {
          isSearch: true,
          isLoc: true,
          location: [location.location.latitude, location.location.longitude],
        };
        setUserLocation(searchLoc);
      }
      loadingDetails = true;
      console.log("loadingDetails in Handler", loadingDetails);
      setListState(2);
      if (brandId) {
        setCurBrand(brandId);
      }
      setCurLoc(location);
      handleCurMarker(locMarker);
    },
    [
      map,
      setCenter,
      setCurBrand,
      setCurLoc,
      setListState,
      handleCurMarker,
      handleAmplitude,
      loadingDetails,
    ],
  );

  return {
    handleCurMarker,
    handleBrandInfoClick,
  };
}
